import { render, staticRenderFns } from "./PartsStoreOrders.vue?vue&type=template&id=695d82b4"
import script from "./PartsStoreOrders.vue?vue&type=script&lang=js"
export * from "./PartsStoreOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports